/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Alarms_Form_Rule_Operator_LtInputs */



/**
* | output |
* | --- |
* | "less than" |
*
* @param {Alarms_Form_Rule_Operator_LtInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const alarms_form_rule_operator_lt = /** @type {((inputs?: Alarms_Form_Rule_Operator_LtInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Alarms_Form_Rule_Operator_LtInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("less than")
	return /** @type {LocalizedString} */ ("inférieure à")
});